<template>
  <div class="ChartShortTerm">
    <div>
      <Tab
        v-for="{ label, value } in timeframeOptions"
        :key="label"
        :isActive="shortTermSelected.timeframe === value.timeframe"
        @click="setTimeframe(value)">
        {{ label }}
      </Tab>
    </div>
    <Field
      label="Rodyti tik aktyvų periodą"
      type="checkbox"
      :value="doShowOnlyRelevantData"
      @update:value="setDoShowOnlyRelevantData" />
  </div>
</template>

<script>
import Tab from 'components/Tab'
import { startOfDay } from 'views/utils'

const getRelativeDate = (offset = 0) => new Date(Date.now() + offset)

export default {
  components: {
    Tab,
  },
  props: {
    shortTermSelected: Object,
    doShowOnlyRelevantData: Boolean,
  },
  data() {
    const DAY_MS = 24 * 60 * 60 * 1000
    const now = getRelativeDate()
    const yesterday = getRelativeDate(-DAY_MS)
    const dayBeforeYesterday = yesterday - DAY_MS

    return {
      timeframeOptions: [
        {
          label: 'Šiandien',
          value: {
            timeframe: 'TODAY',
            recordedAt: {
              $gte: startOfDay(now),
              $lte: now,
            },
          },
        },
        {
          label: 'Vakar',
          value: {
            timeframe: 'YESTERDAY',
            recordedAt: {
              $gte: startOfDay(yesterday),
              $lte: startOfDay(now),
            },
          },
        },
        {
          label: 'Užvakar',
          value: {
            timeframe: 'DAY_BEFORE_YESTERDAY',
            recordedAt: {
              $gte: startOfDay(dayBeforeYesterday),
              $lte: startOfDay(yesterday),
            },
          },
        },
      ],
    }
  },
  methods: {
    setTimeframe(timeframe) {
      if (timeframe === this.shortTermSelected) return

      this.$emit('update:shortTermSelected', timeframe)
    },
    setDoShowOnlyRelevantData() {
      this.$emit('update:doShowOnlyRelevantData', !this.doShowOnlyRelevantData)
    },
  },
}
</script>

<style lang="scss">
.ChartShortTerm {
  display: flex;
  justify-content: space-between;
  padding: $grid-unit $grid-unit 0;
}
</style>
